/* tslint:disable */
/* eslint-disable */
/**
 * Bonds API
 * Microservice backend for bond management
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BankAccountTypeEnum } from './BankAccountTypeEnum';
import {
    BankAccountTypeEnumFromJSON,
    BankAccountTypeEnumFromJSONTyped,
    BankAccountTypeEnumToJSON,
} from './BankAccountTypeEnum';
import type { TypeE38Enum } from './TypeE38Enum';
import {
    TypeE38EnumFromJSON,
    TypeE38EnumFromJSONTyped,
    TypeE38EnumToJSON,
} from './TypeE38Enum';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezone);
/**
 * order_id - foreign key id of Order class instance. Return class
 * object has a foreign key reference to order instance
 * @export
 * @interface Return
 */
export interface Return {
    /**
     * 
     * @type {number}
     * @memberof Return
     */
    readonly id: number;
    /**
     * 
     * @type {number}
     * @memberof Return
     */
    order?: number;
    /**
     * 
     * @type {string}
     * @memberof Return
     */
    creditor: string;
    /**
     * 
     * @type {string}
     * @memberof Return
     */
    readonly issueName: string;
    /**
     * 
     * @type {string}
     * @memberof Return
     */
    bankAccount: string;
    /**
     * 
     * @type {TypeE38Enum}
     * @memberof Return
     */
    type: TypeE38Enum;
    /**
     * 
     * @type {string}
     * @memberof Return
     */
    readonly gross: string;
    /**
     * 
     * @type {string}
     * @memberof Return
     */
    net: string;
    /**
     * 
     * @type {string}
     * @memberof Return
     */
    tax: string;
    /**
     * 
     * @type {Date}
     * @memberof Return
     */
    paid?: Date;
    /**
     * 
     * @type {string}
     * @memberof Return
     */
    variableSymbol?: string;
    /**
     * 
     * @type {string}
     * @memberof Return
     */
    specificSymbol?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof Return
     */
    principalOwnerships: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof Return
     */
    ordersIds?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof Return
     */
    readonly taxRate: string;
    /**
     * 
     * @type {BankAccountTypeEnum}
     * @memberof Return
     */
    bankAccountType?: BankAccountTypeEnum;
}

/**
 * Check if a given object implements the Return interface.
 */
export function instanceOfReturn(value: object): boolean {
    if (!('id' in value)) return false;
    if (!('creditor' in value)) return false;
    if (!('issueName' in value)) return false;
    if (!('bankAccount' in value)) return false;
    if (!('type' in value)) return false;
    if (!('gross' in value)) return false;
    if (!('net' in value)) return false;
    if (!('tax' in value)) return false;
    if (!('principalOwnerships' in value)) return false;
    if (!('taxRate' in value)) return false;
    return true;
}

export function ReturnFromJSON(json: any): Return {
    return ReturnFromJSONTyped(json, false);
}

export function ReturnFromJSONTyped(json: any, ignoreDiscriminator: boolean): Return {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'order': json['order'] == null ? undefined : json['order'],
        'creditor': json['creditor'],
        'issueName': json['issue_name'],
        'bankAccount': json['bank_account'],
        'type': TypeE38EnumFromJSON(json['type']),
        'gross': json['gross'],
        'net': json['net'],
        'tax': json['tax'],
        'paid': json['paid'] == null ? undefined : (dayjs(json['paid']).toDate()),
        'variableSymbol': json['variable_symbol'] == null ? undefined : json['variable_symbol'],
        'specificSymbol': json['specific_symbol'] == null ? undefined : json['specific_symbol'],
        'principalOwnerships': json['principal_ownerships'],
        'ordersIds': json['orders_ids'] == null ? undefined : json['orders_ids'],
        'taxRate': json['tax_rate'],
        'bankAccountType': json['bank_account_type'] == null ? undefined : BankAccountTypeEnumFromJSON(json['bank_account_type']),
    };
}

export function ReturnToJSON(value?: Return | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'order': value['order'],
        'creditor': value['creditor'],
        'bank_account': value['bankAccount'],
        'type': TypeE38EnumToJSON(value['type']),
        'net': value['net'],
        'tax': value['tax'],
        'paid': value['paid'] == null ? undefined : (dayjs(value['paid'] as any).toISOString()),
        'variable_symbol': value['variableSymbol'],
        'specific_symbol': value['specificSymbol'],
        'principal_ownerships': value['principalOwnerships'],
        'orders_ids': value['ordersIds'],
        'bank_account_type': BankAccountTypeEnumToJSON(value['bankAccountType']),
    };
}

